export default __webpack_public_path__ + "static/media/news-03.9c16d9c9.jpg";